// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', danger: '#B03020', success: '#2E6B4A',
  successBg: '#EBF5EF', dangerBg: '#FDECEA',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const RELATION_OPTIONS = [
  { value: 'family_member', label: 'Family Member' },
  { value: 'owner', label: 'Owner' },
  { value: 'renter', label: 'Renter' },
  { value: 'property_manager', label: 'Property Manager' },
  { value: 'caretaker', label: 'Caretaker' },
  { value: 'guest', label: 'Guest' },
]

const ROLE_OPTIONS = [
  { value: 'member', label: 'Member — Can view and edit' },
  { value: 'viewer', label: 'Viewer — Can view only' },
]

const STATUS_STYLES = {
  pending: { bg: '#FBF3E8', color: '#B8721F' },
  accepted: { bg: '#EBF5EF', color: '#2E6B4A' },
  declined: { bg: '#FDECEA', color: '#B03020' },
  expired: { bg: '#F2EDE4', color: '#9A7B68' },
}

export default function InviteModal({ session, homeId, homeAddress, onClose }) {
  const [email, setEmail] = useState('')
  const [relation, setRelation] = useState('family_member')
  const [role, setRole] = useState('member')
  const [sending, setSending] = useState(false)
  const [alert, setAlert] = useState(null)
  const [pendingInvites, setPendingInvites] = useState([])
  const [focus, setFocus] = useState('')

  useEffect(() => { fetchInvites() }, [homeId])

  const fetchInvites = async () => {
    if (!homeId) return
    const { data } = await supabase
      .from('invites').select('*').eq('home_id', homeId)
      .order('created_at', { ascending: false })
    setPendingInvites(data || [])
  }

  const handleSend = async () => {
    if (!email.trim()) { setAlert({ type: 'error', msg: 'Please enter an email address.' }); return }
    if (!homeId) { setAlert({ type: 'error', msg: 'No active home selected.' }); return }
    setSending(true)
    setAlert(null)
    try {
      const firstName = session?.user?.user_metadata?.first_name ||
        session?.user?.user_metadata?.full_name?.split(' ')[0] ||
        session?.user?.email?.split('@')[0] || 'Someone'
      const { error } = await supabase.functions.invoke('send-invite', {
        body: {
          home_id: homeId,
          invited_by: session.user.id,
          invited_email: email.trim().toLowerCase(),
          relation, role,
          invited_by_name: firstName,
          home_address: homeAddress,
        },
      })
      if (error) throw error
      setAlert({ type: 'success', msg: `Invitation sent to ${email}!` })
      setEmail('')
      fetchInvites()
    } catch {
      setAlert({ type: 'error', msg: 'Failed to send invite. Please try again.' })
    }
    setSending(false)
  }

  const handleCancel = async (inviteId) => {
    await supabase.from('invites').update({ status: 'expired' }).eq('id', inviteId)
    fetchInvites()
  }

  const inp = (foc) => ({
    width: '100%', background: C.bg, border: `1px solid ${focus === foc ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px', fontFamily: f, color: C.brown,
    boxSizing: 'border-box', outline: 'none', marginBottom: '14px', transition: 'border-color 0.2s',
    cursor: 'pointer',
  })
  const lbl = { fontSize: '10px', color: C.muted, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '5px', display: 'block', fontFamily: fs }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px', fontFamily: f }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: C.card, borderRadius: '16px', width: '100%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 40px rgba(44,29,20,0.2)', border: `1px solid ${C.border}` }}>
        <div style={{ padding: '24px 28px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown }}>Invite Someone</div>
          <button style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 }} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: '8px 28px 28px' }}>
          <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs, marginBottom: '20px' }}>
            Share access to <strong style={{ color: C.brown }}>{homeAddress}</strong> on Casavio.
          </div>

          {alert && (
            <div style={{ borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', fontFamily: fs, background: alert.type === 'error' ? C.dangerBg : C.successBg, border: `1px solid ${alert.type === 'error' ? C.danger : C.success}44`, color: alert.type === 'error' ? C.danger : C.success }}>
              {alert.msg}
            </div>
          )}

          <label style={lbl}>Email Address</label>
          <input
            style={{ ...inp('email'), cursor: 'text' }}
            type="email" placeholder="name@example.com"
            value={email} onChange={e => { setEmail(e.target.value); setAlert(null) }}
            onFocus={() => setFocus('email')} onBlur={() => setFocus('')}
          />

          <label style={lbl}>Their Role at This Home</label>
          <select style={inp('relation')} value={relation} onChange={e => setRelation(e.target.value)} onFocus={() => setFocus('relation')} onBlur={() => setFocus('')}>
            {RELATION_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>

          <label style={lbl}>Access Level</label>
          <select style={inp('role')} value={role} onChange={e => setRole(e.target.value)} onFocus={() => setFocus('role')} onBlur={() => setFocus('')}>
            {ROLE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>

          <button
            style={{ width: '100%', background: sending ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`, border: 'none', borderRadius: '10px', padding: '14px', color: sending ? C.muted : C.card, fontSize: '14px', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', cursor: sending ? 'not-allowed' : 'pointer', fontFamily: f }}
            onClick={handleSend} disabled={sending}
          >
            {sending ? 'Sending...' : 'Send Invitation'}
          </button>

          {pendingInvites.length > 0 && (
            <>
              <div style={{ fontSize: '11px', color: C.muted, letterSpacing: '2px', textTransform: 'uppercase', marginTop: '28px', marginBottom: '12px', fontFamily: fs }}>Invitations</div>
              {pendingInvites.map(inv => {
                const st = STATUS_STYLES[inv.status] || STATUS_STYLES.pending
                return (
                  <div key={inv.id} style={{ background: C.bg, borderRadius: '10px', border: `1px solid ${C.border}`, padding: '12px 14px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: C.brown, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{inv.invited_email}</div>
                      <div style={{ fontSize: '11px', color: C.muted, fontFamily: fs, marginTop: '2px' }}>
                        {RELATION_OPTIONS.find(o => o.value === inv.relation)?.label || inv.relation}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                      <span style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '20px', background: st.bg, color: st.color, fontFamily: fs, border: `1px solid ${st.color}33` }}>
                        {inv.status}
                      </span>
                      {inv.status === 'pending' && (
                        <button style={{ background: 'transparent', border: 'none', fontSize: '11px', color: C.muted, cursor: 'pointer', fontFamily: fs, padding: 0 }} onClick={() => handleCancel(inv.id)}>
                          Cancel
                        </button>
                      )}
                    </div>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
